import './styles.css';

import { createRouter, RouterProvider } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Toaster } from '@upcaret/ui/sonner';
import { UserContextProvider } from '@upcaret/ui/auth';

import { ThemeProvider } from '@upcaret/ui/theme-provider';
import ReactDOM from 'react-dom/client';

const queryClient = new QueryClient();

export const router = createRouter({
  routeTree,
  context: {
    queryClient: queryClient,
    user: null,
    session: null,
    subscription: null,
    pageTitle: 'Cently',
  },
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function InnerApp() {
  const context = {};

  return (
    <>
      <RouterProvider router={router} context={context} />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider queryClient={queryClient}>
        <InnerApp />
      </UserContextProvider>
    </QueryClientProvider>
  );
}

// Render the app
const rootElement = document.getElementById('root');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // <StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <App />
    </ThemeProvider>,
    // </StrictMode>
  );
}

// https://github.com/vitejs/vite/issues/11804#issuecomment-2364075274
window.addEventListener('vite:preloadError', (event) => {
  console.log(event);
  console.warn('new version found.  reloading...');
  window.location.reload();
});

// Trigger a service worker update check on every hard page load
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistration().then((registration) => {
      registration?.update?.();
    });
  });
}
